export default "__VITE_ASSET__fsDabGt2__"